
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tajweed-colors",
      function () {
        return require("private-next-pages/tajweed-colors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tajweed-colors"])
      });
    }
  